import {useAntCharts} from "../../charts/ant/useAntCharts";
import React, {useMemo} from "react";
import {Heatmap} from "@ant-design/plots";

const StyleboxHeatmap = ({ size, style }) => {
    const { axisConfig } = useAntCharts()
    // Combine size and style arrays into meaningful combinations
    const heatmapData = useMemo(() => {
        const data = [];

        size.forEach((sizeItem) => {
            style.forEach((styleItem) => {
                const comboValue = sizeItem.v * styleItem.v;
                data.push({
                    size: sizeItem.k.toUpperCase(),
                    style: styleItem.k.toUpperCase(),
                    value: comboValue * 100,
                });
            });
        });

        return data;
    }, [size, style]);

    console.log(heatmapData)

    // Config for Ant Design Heatmap component
    const config = {
        data: heatmapData,
        xField: 'style', // Style will be represented on the x-axis
        yField: 'size',  // Size will be represented on the y-axis
        colorField: 'value',
        sizeField: 'value', // Used to determine the size of the circles
        shapeField: 'point',
        scale: {
            size: {
                range: [10, 25],
            },
            color: { range: ['linear-gradient(to bottom right, #50c878, #006400)', 'linear-gradient(to bottom right, #c0c0c0, #7a7a7a)', 'linear-gradient(to bottom right, #00bfff, #000080)'] },

        },

        axis: {
            x: {...axisConfig, style: {fontSize: 16}},
            y: {...axisConfig, style: {fontSize: 16}}
        }

    };

    return <Heatmap {...config} />

};



export default StyleboxHeatmap;